<div class="row submitPetition">
    <div class="col-12 pt-3">
      <div class="row">
        <div class="col-10 p-0" *ngIf="isDataLoaded">
          <app-wizard-head [wizardInput]="wizardInput"></app-wizard-head>
        </div>
      </div>
    </div> 
    <div class="col-12 contentPortion p-0 page-header" *ngIf="isDataLoaded">
      <h5 class="mb-2">1. Submit Petition</h5>
      <submit-petition-library [simplifyH1b]="true" [isWizardFlag]="true"
      [primaryData]="inputData" style="width:100%" (onUpdateStatus)="updateTaskStatus()"></submit-petition-library>
    </div>
    <div class="col-12 contentPortion p-0 page-header" *ngIf="isDataLoaded">
      <h5 class="mb-2">2. Get Receipts</h5>
      <get-receipts-library [simplifyH1b]="true" [isWizardFlag]="true"
      [primaryData]="inputData2" style="width:100%"></get-receipts-library>
    </div>
</div>